import ModalProvider from "@repo/components/src/globalProviders/modal";
import { DataGrid } from "@repo/components/src/shared/dataGrid";
import { Column } from "@repo/components/src/shared/dataGrid/types";
import { BasicModal } from "@repo/components/src/shared/modal";
import { Badge, BadgeText } from "@repo/components/src/ui/badge";
import { Box } from "@repo/components/src/ui/box";
import { Button, ButtonText } from "@repo/components/src/ui/button";
import { Heading } from "@repo/components/src/ui/heading";
import { Link, useGlobalSearchParams } from "expo-router";
import React from "react";

type ItemProp = {
  feature: string;
  available: boolean;
};

const data: ItemProp[] = [
  { feature: "Búsqueda de creadores", available: false },
  { feature: "Crear campañas", available: false },
  { feature: "Pagos pendientes para campañas", available: false },
  { feature: "Enviar ODT's", available: false },
];

const columns: Column<ItemProp>[] = [
  {
    id: "feature",
    header: "Funcionalidad",
    sortable: false,
    getValue: (item) => item.feature,
  },
  {
    id: "Disponibilidad",
    header: "Disponibilidad",
    sortable: false,
    width: 180,
    render: (item) => {
      if (item.available) {
        return (
          <Badge
            className="w-fit bg-background-200 border-background-300"
            rounded="lg"
          >
            <BadgeText className="text-typography-500" bold>
              Disponible
            </BadgeText>
          </Badge>
        );
      }
      return (
        <Badge
          className="w-fit bg-background-100 border-background-200"
          rounded="lg"
        >
          <BadgeText className="text-typography-400" bold>
            No disponible
          </BadgeText>
        </Badge>
      );
    },
  },
];

const KnowMore = React.memo(() => {
  const { brandId } = useGlobalSearchParams<{ brandId: string }>();
  return (
    <BasicModal>
      <Heading size="2xl" className="text-center">
        Perderás las mejores funciones :(
      </Heading>
      <Box className="mt-6 flex-1">
        <DataGrid
          data={data}
          columns={columns}
          getId={(item) => item.feature}
          checkbox={false}
        />
      </Box>
      <Link
        asChild
        href={{
          pathname: "/app/(brands)/settings/plan",
        }}
      >
        <Button
          action="brand"
          variant="solid"
          size="md"
          className="w-fit self-center mt-4"
          rounded="lg"
          onPress={ModalProvider.hide}
        >
          <ButtonText>Ver planes</ButtonText>
        </Button>
      </Link>
    </BasicModal>
  );
});

KnowMore.displayName = "KnowMore";

export default KnowMore;
